import { hasValue } from '@famly/stat_ts-utils_has-value';
export class Debounced {
    constructor(callback, options) {
        var _a;
        this.timeoutMs = 500;
        this.call = (...args) => {
            this.clearTimeout();
            this.timeout = setTimeout(() => this.execute(...args), this.timeoutMs);
        };
        this.execute = (...args) => {
            this.clearTimeout();
            if (this.cb) {
                this.cb(...args);
            }
        };
        this.clearTimeout = () => {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = undefined;
        };
        this.cb = callback;
        if (hasValue(options)) {
            this.timeoutMs = (_a = options.timeoutMs) !== null && _a !== void 0 ? _a : this.timeoutMs;
        }
    }
}
